var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.2298 44.16C73.2298 44.16 73.3098 37.36 74.1298 32.93C74.6798 29.9 73.9898 23.43 69.7798 18.09C67.1198 14.72 62.0298 10.57 52.7398 10H47.6398C38.5098 10.58 33.4198 14.72 30.7598 18.09C26.5498 23.43 25.8498 29.9 26.4098 32.93C27.2198 37.36 27.3098 44.14 27.3098 44.14C27.3098 44.14 27.1898 44.49 27.1298 44.66C26.5098 46.26 26.0698 47.97 27.0098 52.65C28.0698 57.96 29.7398 60.75 30.9798 62.16C31.4098 65.45 32.6298 69.11 33.6698 71.29C34.4198 72.89 34.7798 75.05 34.7798 78.12C34.7798 80.97 34.6698 81.01 34.0198 81.21C26.3098 83.47 8.81977 95.29 2.00977 98",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0002 97.79C91.0002 95.07 73.3102 83.34 65.7402 81.12C65.0502 80.91 64.9502 80.87 64.9502 78.02C64.9502 75.67 65.9302 73.29 66.8702 71.29",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4702 74.0601C34.4702 74.0601 41.7402 80.2501 50.4102 80.2501C59.0802 80.2501 65.7202 74.0601 65.7202 74.0601",
    stroke: "#084298",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6599 54.1499C72.3799 61.1699 63.8099 65.6399 54.3999 67.1499",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0099 47.53L18.9199 30.56C18.9199 13.62 32.8299 2 49.9999 2C67.1599 2 81.0799 13.62 81.0799 30.56L79.9899 47.53",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 35.5L14.01 48",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5002 35.5L85.9902 48",
    stroke: "#3D8BFD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2c22219ba7dbfbc8ce092eb028d23719.svg";
export { ForwardRef as ReactComponent };